// Library Imports
import Vue from "vue";
import App from "./App.vue";
import vuetify from "@/plugins/vuetify";
import router from "@/router/index";

// Vars Imports
import globalObject from "@/utils/globalConfig";
import axiosInstance from "@/plugins/axios";
import wbSocket from "@/plugins/wbSocket";
import api from "@/plugins/api";
import { previewFormate } from "@/plugins/filters";

import InputField from "@/components/ComponentLibrary/FormInput/InputField.vue";
import SelectField from "@/components/ComponentLibrary/FormInput/SelectField.vue";
import FileField from "@/components/ComponentLibrary/FormInput/FileField.vue";
import SwitchField from "@/components/ComponentLibrary/FormInput/SwitchField.vue";
import TextAreaField from "@/components/ComponentLibrary/FormInput/TextAreaField.vue";
import DatePicker from "@/components/ComponentLibrary/FormInput/DatePicker.vue";
import DateTimeField from "@/components/ComponentLibrary/FormInput/DateTimeField.vue";
import ProfileUpload from "@/components/ComponentLibrary/FormInput/ProfileUpload.vue";
import PasswordField from "@/components/ComponentLibrary/FormInput/PasswordField.vue";
import FileUpload from "@/components/ComponentLibrary/FormInput/FileUpload.vue";
import WeekDays from "@/components/ComponentLibrary/FormInput/WeekDays.vue";
import CustomFieldRenderForm from "@/components/ComponentLibrary/FormInput/CustomFieldRenderForm.vue";
import ColorPickerField from "@/components/ComponentLibrary/FormInput/ColorPickerField.vue";

import PrimaryButton from "@/components/ComponentLibrary/Buttons/PrimaryButton.vue";
import SecondaryButton from "@/components/ComponentLibrary/Buttons/SecondaryButton.vue";
import ErrorButton from "@/components/ComponentLibrary/Buttons/ErrorButton.vue";
import WarningButton from "@/components/ComponentLibrary/Buttons/WarningButton.vue";
import SuccessButton from "@/components/ComponentLibrary/Buttons/SuccessButton.vue";

import BarChart from "@/components/ComponentLibrary/Charts/BarChart.vue";
import DoughnutChart from "@/components/ComponentLibrary/Charts/DoughnutChart.vue";
import RadarChart from "@/components/ComponentLibrary/Charts/RadarChart.vue";
import LineChart from "@/components/ComponentLibrary/Charts/LineChart.vue";
import PieChart from "@/components/ComponentLibrary/Charts/PieChart.vue";
import StackedBarChart from "@/components/ComponentLibrary/Charts/StackedBarChart.vue";
import TwoBarChart from "@/components/ComponentLibrary/Charts/TwoBarChart.vue";

import getAllFunction from "./utils/functions.js";
import per from "./plugins/permissions.js";

import VueCountdown from "@chenfengyuan/vue-countdown";
import VueConfetti from "vue-confetti";
import store from "./store";

export const bus = new Vue();

Vue.component("ColorPicker", ColorPickerField);
Vue.component("FileUpload", FileUpload);
Vue.component("InputField", InputField);
Vue.component("SelectField", SelectField);
Vue.component("FileField", FileField);
Vue.component("SwitchField", SwitchField);
Vue.component("TextAreaField", TextAreaField);
Vue.component("DatePicker", DatePicker);
Vue.component("DateTimeField", DateTimeField);
Vue.component("ProfileUpload", ProfileUpload);
Vue.component("PasswordField", PasswordField);
Vue.component("WeekDays", WeekDays);
Vue.component("CustomFieldRenderForm", CustomFieldRenderForm);

Vue.component("PrimaryButton", PrimaryButton);
Vue.component("SecondaryButton", SecondaryButton);
Vue.component("ErrorButton", ErrorButton);
Vue.component("WarningButton", WarningButton);
Vue.component("SuccessButton", SuccessButton);

Vue.component("BarChart", BarChart);
Vue.component("RadarChart", RadarChart);
Vue.component("DoughnutChart", DoughnutChart);
Vue.component("LineChart", LineChart);
Vue.component("PieChart", PieChart);
Vue.component("StackedBarChart", StackedBarChart);
Vue.component("TwoBarChart", TwoBarChart);

Vue.component(VueCountdown.name, VueCountdown);
Vue.use(VueConfetti);
Vue.config.productionTip = false;
Vue.use(require("vue-shortkey"));

Vue.prototype.$axios = axiosInstance;
Vue.prototype.$api = api;
Vue.prototype.$globalConstant = globalObject;
Vue.prototype.$helper = getAllFunction;
Vue.prototype.$permissions = per;
Vue.prototype.$wbSocket = wbSocket;

Vue.filter("formatDate", previewFormate);

new Vue({
  vuetify,
  router,
  store,
  beforeMount() {
    this.$store.commit("userProfile/initialiseStore");
  },
  render: (h) => h(App),
}).$mount("#app");
